module.exports = __webpack_public_path__ + "static/media/LVA.19bce69a.jpg";